import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import SvgIcon from './SvgIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var OmniQueueIcon = function OmniQueueIcon(props) {
  return /*#__PURE__*/_jsx(SvgIcon, _objectSpread(_objectSpread({}, props), {}, {
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    children: /*#__PURE__*/_jsx("g", {
      id: "Page-1",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/_jsx("g", {
        id: "Omni-queue-icon",
        transform: "translate(-119.000000, -326.000000)",
        children: /*#__PURE__*/_jsxs("g", {
          id: "-g--omni-queue-24px",
          transform: "translate(117.000000, 324.000000)",
          fill: "currentColor",
          fillRule: "nonzero",
          children: [/*#__PURE__*/_jsx("rect", {
            id: "Rectangle",
            x: "0",
            y: "0",
            width: "24",
            height: "24"
          }), /*#__PURE__*/_jsx("polygon", {
            id: "Path",
            points: "13.79 8 15.59 5 13.79 2 10.21 2 8.41 5 10.21 8"
          }), /*#__PURE__*/_jsx("polygon", {
            id: "Path",
            points: "16.45 11.51 20.04 11.51 21.83 8.51 20.04 5.51 16.45 5.51 14.65 8.51"
          }), /*#__PURE__*/_jsx("polygon", {
            id: "Path",
            points: "20.04 12.51 16.45 12.51 14.65 15.51 16.45 18.51 20.04 18.51 21.83 15.51"
          }), /*#__PURE__*/_jsx("polygon", {
            id: "Path",
            points: "7.55 11.51 9.35 8.51 7.55 5.51 3.96 5.51 2.17 8.51 3.96 11.51"
          }), /*#__PURE__*/_jsx("polygon", {
            id: "Path",
            points: "7.55 12.51 3.96 12.51 2.17 15.51 3.96 18.51 7.55 18.51 9.35 15.51"
          }), /*#__PURE__*/_jsx("polygon", {
            id: "Path",
            points: "10.21 16 8.41 19 10.21 22 13.79 22 15.59 19 13.79 16"
          })]
        })
      })
    })
  }));
};
export default OmniQueueIcon;